import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { AppComponent } from '../app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-vendor-profile',
  templateUrl: './vendor-profile.component.html',
  styleUrls: ['./vendor-profile.component.scss'],
})
export class VendorProfileComponent {
  getId;
  proof: boolean;
  account: boolean;
  log: boolean = false;
  conf: boolean = true;
  url;
  Proof;
  AdsProof;
  id;
  verified: boolean = false;
  name;
  housenbr;
  loader: boolean = true;
  street;
  city;
  region;
  state;
  getData;
  mob;
  zipcode;
  Proid;
  confirm: boolean;
  pend: boolean = false;
  id1;
  credits;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public app: AppComponent,
    public santinzer: DomSanitizer,
    public platform: Platform) { }

  ionViewWillEnter() {
    this.url = window.location.href;
    if (this.url.includes('vendorAdminProfile')) {
      this.id = localStorage.getItem('currentUserId');
      this.log = true;
      this.conf = false;
    } else {
      this.id = this.url.split('/').pop();
    }
    this.Proid = localStorage.getItem('currentUserId');
    this.basicDetails();

  }

  modelChanged(data) {
    if (data) {
      this.confirm = true;
    } else {
      this.pend = true;
    }
  }
  cancel() {
    this.confirm = false;
    this.verified = false;
  }

  basicDetails() {
    if (this.url.includes('vendorProfile')) {
      this.service.getAddressById(this.id).subscribe((res: any) => {
        this.getData = res;
        this.name = this.getData.firstName;
        this.verified = res.verified;
        if (res.userCredits.length > 0)
          this.credits = res.userCredits[0].creditPoints;
        else
          this.credits = 0;
        let x = res.roles;
        if (sessionStorage.getItem('roleId')) {
          let rolecode = sessionStorage.getItem('roleId')
          let y = x.find(dat1 => { return dat1.code == rolecode })
          this.id1 = y.roleId
        }
        this.loader = false;

      }, err => {
        this.loader = false;
        this.handler.err(err);
      });
    } else if (this.url.includes('vendorAdminProfile')) {
      this.service.getAddressById(this.Proid).subscribe((res: any) => {
        this.getData = res;
        this.conf = false;
        this.name = this.getData.firstName;
        if (res.userCredits.length > 0)
          this.credits = res.userCredits[0].creditPoints;
        else
          this.credits = 0;
        this.verified = res.verified;
        this.loader = false;
      }, err => {
        this.loader = false;
        this.handler.err(err);
      });
    }
  }

  editProfile() {
    if ((this.auth.checkCapability('SC') || (this.auth.checkCapability('SP')) && !this.auth.checkCapability('FSA'))) {
      if (this.url.includes('vendorProfile')) {
        this.router.navigate(['vendorProfileViewUser/', this.id])
      } else {
        this.router.navigate(['contractorProfileView/', this.id])
      }
    } else if (this.auth.checkCapability('SC') && this.auth.checkCapability('SP')) {
      this.router.navigate(['contractorProfileView/', this.id])
    } else if (this.auth.checkCapability('SP') && this.auth.checkCapability('FSA')) {
      if (this.url.includes('vendorProfile')) {
        this.router.navigate(['vendorProfileViewUser/', this.id])
      } else {
        this.router.navigate(['contractorProfileView/', this.id])
      }
    } else if (this.auth.checkCapability('FAS') && this.auth.checkCapability('SPVR')) {
      this.router.navigate(['contractorProfileView/', this.id])

    }
    else {
      this.router.navigate(['vendorProfileViewUser/', this.id])
    }

  }

  Awards() {
    this.router.navigate(['awards/', this.id]);
  }

  category() {
    if (this.auth.checkCapability('SC') || (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))) {
      this.router.navigate(['cotractorCategory/', this.id])
    } else {
      this.router.navigate(['tagCategory/', this.id])
    }

  }
  bill() {
    this.router.navigate(['billings/', this.id])
  }

  doc(id) {
    if (this.auth.checkCapability('SC') || (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))) {
      if (id == 1) {
        this.router.navigate(['check-document/', this.id]);
      } else {
        this.router.navigate(['check-Address/', this.id]);
      }
    } else {
      if (id == 1) {
        this.router.navigate(['document-identity/', this.id]);
      } else {
        this.router.navigate(['document-Address/', this.id]);
      }
    }

    // this.router.navigate(['document/',id,this.id]);
  }
  add() {
    this.router.navigate(['addDetails/', this.id])
  }
  bank() {
    this.router.navigate(['bankdetails/', this.id])
  }

  login() {
    this.router.navigate(['/vendorLogin']);
  }

  selectToggle() {
    if (this.verified) {
      Object.assign(this.getData, { "verified": true })
      this.service.postProfileDetails(this.id, this.getData).subscribe(res => {
        this.handler.res('Profile Verified Successfully')
        if (this.url.includes('vendorProfile1')) {
          this.router.navigate(['user'])
        } else {
          this.router.navigate(['vendor-approval'])
        }
      }, err => {
        this.handler.err(err)
      })
    } else {
      this.ionViewWillEnter();
    }
  }

  logout() {
    this.loader = true;
    // let post ={
    //    "userId": localStorage.getItem('currentUserId')       }
    //     this.auth.LogOut(post).subscribe(res => {
    //     localStorage.clear();
    //     sessionStorage.clear();  
    //     this.handler.res('Thank You Visit Again !!')
    //     this.loader = false;
    //     this.router.navigate(['/bookservice']);
    //   }, err => {
    //     this.handler.err(err);
    //     localStorage.clear(); 
    //     sessionStorage.clear();
    //     this.loader = false;
    //     this.router.navigate(['/bookservice']);
    //   }) 
    localStorage.clear();
    sessionStorage.clear();
    this.handler.res('Logged Out Successfully !!')
    this.router.navigate(['/vendor-register']);
    this.loader = false;

  }

  ionViewWillLeave() {
    this.getData = "";
    this.name = "";
    this.loader = true;

  }
  reject() {
    this.service.vendorReject(this.id, this.id1).subscribe(res => {
      this.pend = false;
      this.router.navigate(['user'])
    })
  }
  appro() {
    this.pend = false;
    this.verified = true;
  }

}
